import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { useT } from "@/lib/i18n";

const inputCls = "mt-1.5 w-full bg-[#FAF7F2] border border-[#E6E1DA] rounded-xl px-4 py-3 text-sm text-[#1F1D1B] focus:outline-none";
const labelCls = "text-xs font-medium uppercase tracking-wider text-[#6B6560]";

export const CustomerAuthForm = ({ restaurantId, accent, onSuccess }) => {
  const { t } = useT();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ phone: "", password: "", name: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const body = mode === "login" ? { phone: form.phone, password: form.password } : form;
      const { data } = await api.post(`/restaurants/${restaurantId}/customer/${mode === "login" ? "login" : "register"}`, body);
      onSuccess(data);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  const tab = (m, label) => (
    <button type="button" data-testid={`customer-auth-tab-${m}`} onClick={() => { setMode(m); setError(""); }} className={`rounded-full py-2 text-sm font-semibold transition-colors ${mode === m ? "text-white" : "text-[#6B6560]"}`} style={mode === m ? { backgroundColor: accent } : {}}>
      {label}
    </button>
  );

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="customer-auth-form">
      <div className="grid grid-cols-2 gap-1 bg-[#F0EBE3] rounded-full p-1">
        {tab("login", t("logIn"))}
        {tab("register", t("createAccount"))}
      </div>
      {mode === "register" && (
        <div>
          <label className={labelCls}>{t("yourName")}</label>
          <input data-testid="customer-auth-name" value={form.name} onChange={set("name")} placeholder={t("yourName")} className={inputCls} />
        </div>
      )}
      <div>
        <label className={labelCls}>{t("phone")}</label>
        <input data-testid="customer-auth-phone" required type="tel" value={form.phone} onChange={set("phone")} placeholder="+1 555 123 4567" className={inputCls} />
      </div>
      <div>
        <label className={labelCls}>{t("password")}</label>
        <input data-testid="customer-auth-password" required type="password" minLength={4} value={form.password} onChange={set("password")} placeholder={t("passwordPh")} className={inputCls} />
      </div>
      {error && <p data-testid="customer-auth-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</p>}
      <button data-testid="customer-auth-submit" type="submit" disabled={busy} className="w-full rounded-full py-3.5 font-bold text-white flex items-center justify-center gap-2 disabled:opacity-60" style={{ backgroundColor: accent }}>
        {busy && <Loader2 className="h-5 w-5 animate-spin" />} {mode === "login" ? t("logIn") : t("createAccount")}
      </button>
      {mode === "login" && <p className="text-xs text-center text-[#6B6560]">{t("forgot")}</p>}
    </form>
  );
};
